import { VolumeDown, VolumeUp } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import type { DeviceBulkSelectionInput } from '~/generated/graphql';
import { DeviceCommandKind } from '~/generated/graphql';
import { DeviceSliderDialog } from './DeviceSliderDialog';

interface VolumeDialogProps {
  onClose: () => void;
  onComplete?: () => void;
  open: boolean;
  selected: DeviceBulkSelectionInput;
}

export const VolumeDialog = ({ onClose, onComplete, open, selected }: VolumeDialogProps) => {
  const { t } = useTranslation();

  return (
    <DeviceSliderDialog
      onClose={onClose}
      onComplete={onComplete}
      open={open}
      selected={selected}
      command={DeviceCommandKind.Volume}
      defaultValue={0}
      Icon={VolumeUp}
      title={t('pages.devices.dialogs.volume.title')}
      buttonText={t('pages.devices.dialogs.volume.set_button')}
      LeftIcon={VolumeDown}
      RightIcon={VolumeUp}
    />
  );
};
